// src/App.js - SIMPLE FIX
import React from 'react';

function App() {
  return (
    <div style={{ display: 'none' }}>
      {/* Empty div, your HTML will load from public/index.html */}
    </div>
  );
}

export default App;
